import PropTypes from "prop-types"
import React from "react"

export const TemplateIcon = ({ height = 24, width = 24, fill = 'var(--color-primary)', className, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 186 246"
    fill="none"
    className={className}
    {...props}
  >
    <g clipPath="url(#clip0_34092_166699)">
      <rect width="186" height="246" fill="#3487F6" />
      <circle cx="108.5" cy="192.5" r="87.5" fill="#E9ECEF" fillOpacity="0.14" />
      <circle cx="65.5" cy="96.5" r="55.5" fill="#E9ECEF" fillOpacity="0.14" />
    </g>
    <defs>
      <clipPath id="clip0_34092_166699">
        <rect width="186" height="246" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

TemplateIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
  className: PropTypes.string
}
